export const NEW_APPLICATIONS_ROOT = '/newApps';
export const PATH_LOCAL_APPS_LIST = `${NEW_APPLICATIONS_ROOT}/list`;
export const PATH_LOCAL_APPS_CREATE = `${NEW_APPLICATIONS_ROOT}/create`;
export const PATH_LOCAL_APPS_EXACT = `${NEW_APPLICATIONS_ROOT}/exact/:id`;
//
export const UNAVAILABLE_STATUS = 'unavailiable';
export const AVAILABLE_STATUS = 'available';
export const STAGING_STATUS = 'staging';